import { PropsWithChildren, useLayoutEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'
import { useLayoutContext } from './useLayoutContext'
import { TOP_BANNER_HEIGHT } from './TopBanner/constants'
import { PageContainer } from './PageContainer'

interface DeprecatedLayoutProps extends PropsWithChildren {
  /** Scrolls the page inside the shell's panel instead of the document */
  scrollsInPanel?: boolean
}

/** For pages built on legacy `@workwhile/ui`. New pages shouldn't use it */
export const DeprecatedLayout = (props: DeprecatedLayoutProps) => {
  const { children, scrollsInPanel } = props
  const { showTopBanner } = useLayoutContext()
  const { pathname } = useLocation()
  const containerRef = useRef<HTMLDivElement>(null)

  // ScrollRestoration only resets the document, so reset the panel per route
  useLayoutEffect(() => {
    if (!scrollsInPanel || !containerRef.current) {
      return
    }
    containerRef.current.scrollTop = 0
  }, [pathname, scrollsInPanel])

  return (
    <PageContainer
      ref={containerRef}
      $bannerHeight={showTopBanner ? TOP_BANNER_HEIGHT : 0}
      $scrollsInPanel={scrollsInPanel}
    >
      {children}
    </PageContainer>
  )
}
